import React from 'react'
import SwaggerUI from 'swagger-ui-react'
import Footer from './Footer/Footer'
import Header from './Header/Header'

// Import Loyalty Swagger Spec
import { B2BRewardsSpec } from '../spec/B2BRewardsSpec';

export default function SwaggerB2bRewardsSpec() {
  const DisableTryItOutPlugin = function () {
    return {
      statePlugins: {
        spec: {
          wrapSelectors: {
            allowTryItOutFor: () => () => false
          }
        }
      }
    }
  }
  return (
    <div className="App">
      <Header />
      <SwaggerUI spec={B2BRewardsSpec} plugins={DisableTryItOutPlugin} />
      <footer className="FooterClass">
        <Footer />
      </footer>
    </div>
  )
}

